// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__Gu0Md","rotation":"styles_rotation__4ErfY"};